import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Guest Application Root Component
 *
 * Minimal root component for guest users accessing the application.
 * Unlike the main AppComponent, this component:
 * - Does not inject authentication services
 * - Does not set up WebSocket connections
 * - Does not listen for logout events
 * - Does not initialize phone/SIP services
 * - Does not set up Electron IPC listeners
 *
 * It only provides the basic shell for routing and language setup.
 * This ensures complete isolation from authenticated user flows.
 */
@Component({
  selector: 'app-guest-app-root',
  template: `
    <!-- Simple container for guest routes -->
    <div class="guest-app-container">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [
    `
      .guest-app-container {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
      }
    `,
  ],
})
export class GuestAppComponent implements OnInit {
  constructor(private translateService: TranslateService) {
    // Set up basic translation support
    this.setupTranslations();
  }

  ngOnInit(): void {
    console.log('[GUEST-APP] Guest application root component initialized');
    // No service initialization
    // No event bus subscriptions
    // No WebSocket connections
  }

  private setupTranslations(): void {
    // Set default language
    this.translateService.setDefaultLang('en');

    // Try to use browser language, fallback to English
    const browserLang = this.translateService.getBrowserLang();
    const langToUse = browserLang?.match(/en|es|fr/) ? browserLang : 'en';
    this.translateService.use(langToUse);

    console.log(`[GUEST-APP] Language set to: ${langToUse}`);
  }
}
